import { useEffect, useState } from 'react';

import { getPasswordStrength } from './utils';

/**
 * The "watch" here is returned from something like "form.watch('password')"
 * via "react-hook-form".
 * @param watch
 * @param password
 */
export const usePasswordStrength = (watch: string, password: string) => {
  const [strength, setStrength] = useState(0);

  useEffect(() => {
    setStrength(getPasswordStrength(password));
  }, [watch]);

  return strength;
};
